/* D'BakerAid — global video mute/unmute controls
 * Auto-attaches an unmute button to every <video> on the page.
 * Re-runs on shopify:section:load so it works with theme editor + ajax updates.
 */
(function () {
  'use strict';

  var BTN_CLASS = 'dba-video-toggle';
  var WRAP_CLASS = 'dba-video-wrap';

  function injectStyles() {
    if (document.getElementById('dba-video-controls-css')) return;
    var css = ''
      + '.' + WRAP_CLASS + '{position:relative;display:inline-block;width:100%;}'
      + '.' + BTN_CLASS + '{'
      + '  position:absolute;bottom:14px;right:14px;z-index:5;'
      + '  width:42px;height:42px;border-radius:999px;'
      + '  background:rgba(26,15,8,0.72);color:#fff;'
      + '  border:1px solid rgba(255,255,255,0.22);'
      + '  display:inline-flex;align-items:center;justify-content:center;'
      + '  cursor:pointer;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);'
      + '  transition:background .2s,transform .2s,box-shadow .2s;'
      + '  box-shadow:0 4px 14px rgba(0,0,0,0.18);'
      + '  padding:0;'
      + '}'
      + '.' + BTN_CLASS + ':hover{background:rgba(26,15,8,0.92);transform:translateY(-1px);box-shadow:0 6px 18px rgba(0,0,0,0.28);}'
      + '.' + BTN_CLASS + ':focus-visible{outline:2px solid #FDC656;outline-offset:2px;}'
      + '.' + BTN_CLASS + ' svg{width:18px;height:18px;display:block;pointer-events:none;}'
      + '.' + BTN_CLASS + '[data-muted="true"] .dba-icon-on{display:none;}'
      + '.' + BTN_CLASS + '[data-muted="false"] .dba-icon-off{display:none;}'
      + '@media (max-width:520px){.' + BTN_CLASS + '{width:38px;height:38px;bottom:10px;right:10px;}.' + BTN_CLASS + ' svg{width:16px;height:16px;}}'
      + '';
    var style = document.createElement('style');
    style.id = 'dba-video-controls-css';
    style.textContent = css;
    document.head.appendChild(style);
  }

  var ICON_MUTED = ''
    + '<svg class="dba-icon-off" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>'
    + '<line x1="23" y1="9" x2="17" y2="15"></line>'
    + '<line x1="17" y1="9" x2="23" y2="15"></line>'
    + '</svg>';
  var ICON_UNMUTED = ''
    + '<svg class="dba-icon-on" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>'
    + '<path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>'
    + '<path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>'
    + '</svg>';

  function attach(video) {
    if (!video || video.dataset.dbaVideoBound === '1') return;
    if (video.controls === true) {
      video.dataset.dbaVideoBound = '1';
      return;
    }
    if (video.hasAttribute('data-no-mute-toggle')) {
      video.dataset.dbaVideoBound = '1';
      return;
    }

    video.dataset.dbaVideoBound = '1';

    var parent = video.parentNode;
    if (!parent) return;
    var wrap;
    if (parent.classList && parent.classList.contains(WRAP_CLASS)) {
      wrap = parent;
    } else {
      var ps = window.getComputedStyle(parent);
      if (ps.position === 'static') {
        wrap = document.createElement('div');
        wrap.className = WRAP_CLASS;
        var vs = window.getComputedStyle(video);
        if (vs.display === 'block' || video.tagName === 'VIDEO') wrap.style.display = 'block';
        parent.insertBefore(wrap, video);
        wrap.appendChild(video);
      } else {
        wrap = parent;
      }
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = BTN_CLASS;
    btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    btn.dataset.muted = video.muted ? 'true' : 'false';
    btn.innerHTML = ICON_MUTED + ICON_UNMUTED;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      video.muted = !video.muted;
      if (!video.muted && video.volume < 0.05) {
        try { video.volume = 0.7; } catch (err) { /* noop */ }
      }
      btn.dataset.muted = video.muted ? 'true' : 'false';
      btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      if (video.paused) {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
    });

    video.addEventListener('volumechange', function () {
      btn.dataset.muted = video.muted ? 'true' : 'false';
      btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    });

    wrap.appendChild(btn);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var videos = scope.querySelectorAll('video');
    for (var i = 0; i < videos.length; i++) attach(videos[i]);
  }

  function init() {
    injectStyles();
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { scan(e.target || document); });
  document.addEventListener('shopify:section:reorder', function () { scan(document); });

  if (typeof MutationObserver === 'function') {
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        if (!added) continue;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!node || node.nodeType !== 1) continue;
          if (node.tagName === 'VIDEO') attach(node);
          else if (node.querySelectorAll) {
            var v = node.querySelectorAll('video');
            for (var k = 0; k < v.length; k++) attach(v[k]);
          }
        }
      }
    });
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();
